import React, { Component } from "react";
import WarningIcon from "@material-ui/icons/Warning";
import DoneOutlineIcon from "@material-ui/icons/DoneOutline";
import ListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import KpsListItem from "../../core-elements/KpsListItem";
import { withRouter } from "react-router";
import { Trans, withTranslation } from "react-i18next";
import { withStyles, withTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import moment from "moment";
import Badge from "@material-ui/core/Badge";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import KpsEditor from "../editor/KpsEditor";
import Checkbox from "@material-ui/core/Checkbox";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { withSnackbar } from "notistack";
import { contentClient } from "../../AxiosClient";
import DisplayLocation from "../taxonomy/discussions/DisplayLocation";
import DisplayUser from "../user/DisplayUser";
import { currentUserHasRole, Role } from "../../utils/RoleUtils";
import KpsTextField from "../KpsTextField";
const styles = (theme) => ({
  iconSpan: {
    "& > svg": {
      verticalAlign: "middle",
    },
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  },
  secondarySpan: {
    verticalAlign: "middle",
    marginLeft: "5px",
    display: "flex",
  },
  wrapper: {
    "& > div": {
      display: "block",
      verticalAlign: "middle",
    },
  },
  urgencyIcon: {
    fontSize: "1.5em",
    marginRight: "3px",
  },
  secondaryInner: {
    "& > p": {
      marginBottom: "0px",
    },
  },
});

export class ItemRework extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
  };
  state = {
    extendedString: "",
    checked: false,
    anchorEl: null,
    rejectReason: "",
  };
  componentDidMount() {
    this.defaultFullscreenInfo(this.props.fullscreenSettings);
    this.secondaryInfo(this.props.listSettings);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.listSettings !== this.props.listSettings) {
      this.secondaryInfo(this.props.listSettings);
    }
    if (this.props.fullscreen != prevProps.fullscreen) {
      if (this.props.fullscreen) {
        this.secondaryInfo(this.props.fullscreenSettings);
      } else {
        this.secondaryInfo(this.props.listSettings);
      }
    }
    if (
      this.props.fullscreenSettings != prevProps.fullscreenSettings &&
      this.props.fullscreen
    ) {
      this.secondaryInfo(this.props.fullscreenSettings);
    }
  }
  render() {
    const { t } = this.props;
    let icon = "";
    let tooltip = "";
    if (this.props.data.status === "OPEN") {
      if (this.props.data.urgency === "High") {
        icon = "mdi-chevron-triple-up";
        tooltip = `${t("global_rework_urgency")}: ${t("rework_urgency_high")}`;
      } else if (this.props.data.urgency === "Medium") {
        icon = "mdi-chevron-double-up";
        tooltip = `${t("global_rework_urgency")}: ${t(
          "rework_urgency_medium"
        )}`;
      } else if (this.props.data.urgency === "Low") {
        icon = "mdi-chevron-up";
        tooltip = `${t("global_rework_urgency")}: ${t("rework_urgency_low")}`;
      }
    } else if (this.props.data.status === "REJECTED") {
      icon = "mdi-close";
      tooltip = t("rework_status_rejected");
    } else if (this.props.data.status === "RESOLVED") {
      icon = "mdi-check";
      tooltip = t("rework_status_resolved");
    }
    return (
      <KpsListItem
        expandOnClick={this.props.documentSidebar}
        preText={this.props.preText}
        isPortlet={this.props.isPortlet}
        extendedString={
          this.props.documentSidebar
            ? this.extendedSideBarInfo()
            : this.extendedNoSideBarInfo()
        }
        provided={this.props.provided}
        onItemClick={this.onItemClick}
        menuDialog={this.props.menuDialog}
        fullscreen={this.props.fullscreen}
        fullscreenSettings={
          this.props.fullscreenSettings &&
          this.props.fullscreenSettings !== null
            ? JSON.parse(this.props.fullscreenSettings).map((setting, idx) => {
                return <>{this.getSettingInfo(setting)}</>;
              })
            : this.state.defaultFullscreen
        }
      >
        {this.props.preText}
        <ListItemAvatar style={{ minWidth: 40 }}>
          {this.props.editing ? (
            <Tooltip title={t("rework_resolve_with_this_revision")}>
              <Checkbox
                onClick={(e) => e.stopPropagation()}
                checked={this.state.checked}
                disabled={
                  this.props.data.status === "REJECTED" ||
                  this.props.data.status === "RESOLVED"
                }
                onChange={(e) => {
                  e.stopPropagation();
                  this.setState({ checked: e.target.checked });
                  this.props.onResolveChange &&
                    this.props.onResolveChange(e.target.checked);
                }}
                inputProps={{ "aria-label": "primary checkbox" }}
              />
            </Tooltip>
          ) : (
            <>
              {!this.props.fullscreen && (
                <Tooltip title={tooltip}>
                  <span
                    style={{ fontSize: "1.5em" }}
                    className={`mdi ${icon}`}
                  />
                </Tooltip>
              )}
            </>
          )}
        </ListItemAvatar>
        {this.props.documentSidebar ? (
          <ListItemText
            style={{ overflowWrap: "anywhere" }}
            primary={
              <DisplayUser
                noAvatar
                userId={this.props.data.creator.userId}
                user={this.props.data.creator}
              />
            }
            secondary={moment(this.props.data.dateCreated).format(
              "DD/MM/YYYY HH:mm"
            )}
          />
        ) : (
          <ListItemText
            style={{ overflowWrap: "anywhere" }}
            primary={this.props.data.targetTitle}
            secondary={this.state.secondaryString}
          />
        )}
      </KpsListItem>
    );
  }
  onItemClick = (e) => {
    if (!this.props.documentSidebar) {
      this.props.history.push(
        `/full/document/${this.props.data.targetDocument}`
      );
    }
  };
  defaultFullscreenInfo(settings) {
    if (!settings || settings.length === 0) {
      settings = [];
      for (let i = 0; i < this.props.reworkOptions.length; i++) {
        settings.push({ label: this.props.reworkOptions[i], order: i });
      }
    } else {
      try {
        let jsonsettings = JSON.parse(settings);
        settings = jsonsettings;
      } catch (x) {
        settings = [{ label: settings, order: 0 }];
      }
    }
    var fullScreenString = (
      <>
        {settings.map((setting, idx) => {
          return <>{this.getSettingInfo(setting)}</>;
        })}
      </>
    );
    this.setState({ defaultFullscreen: fullScreenString });
  }
  getSettingInfo = (setting) => {
    return (
      <>
        {setting.label === "settings_location" && (
          <TableCell>
            {
              <DisplayLocation
                type={"KNOWLEDGE_ITEM"}
                itemId={this.props.data.knowledgeItemId}
                topicId={this.props.data.topicId}
                title={this.props.data.targetTitle}
              />
            }
          </TableCell>
        )}
        {setting.label === "settings_knowledge_item_description" && (
          <TableCell>
            {this.props.data.knowledgeItemDescription !== null &&
            this.props.data.knowledgeItemDescription.trim().length > 0
              ? this.props.data.knowledgeItemDescription +
                " (" +
                this.props.data.knowledgeItemId +
                ") "
              : this.props.t("global_knowledge_item") +
                " (" +
                this.props.data.knowledgeItemId +
                ") "}
          </TableCell>
        )}
        {setting.label === "settings_urgency" && (
          <TableCell>{this.props.data.urgency}</TableCell>
        )}
        {setting.label === "settings_target_completion_date" && (
          <TableCell>
            {moment(this.props.data.targetCompletionDate).format("LLL")}
          </TableCell>
        )}
        {setting.label === "settings_date_created" && (
          <TableCell>
            {moment(this.props.data.dateCreated).format("LLL")}
          </TableCell>
        )}
        {setting.label === "settings_originator" && (
          <TableCell>
            {
              <DisplayUser
                userId={this.props.data.creator.userId}
                user={this.props.data.creator}
              />
            }
          </TableCell>
        )}
        {setting.label === "settings_revision" && (
          <TableCell>{this.props.data.targetTitle}</TableCell>
        )}
        {setting.label === "settings_status" && (
          <TableCell>{this.props.data.status}</TableCell>
        )}
        {setting.label === "settings_author" && (
          <TableCell>
            {
              <DisplayUser
                userId={this.props.data.creator.userId}
                user={this.props.data.creator}
              />
            }
          </TableCell>
        )}
      </>
    );
  };
  getRejectedBy = () => {
    return(
      <>
      {this.props.data.rejectedBy.firstName + " " + 
        this.props.data.rejectedBy.surname + " (" +
        this.props.data.rejectedBy.userLogin + ") " 
      }
      </>
    )
  }
  extendedSideBarInfo = () => {
    const { t } = this.props;
    return (
      <div style={{ margin: 5 }}>
        {this.props.data.status === "REJECTED" && (
          <Typography style={{ fontStyle: "italic" }} variant="caption" gutterBottom>
            {this.props.t("rework_status_rejected_by")}{" "}
            {this.getRejectedBy()} 
            {this.props.t("rework_status_rejected_on")}{" "}
            {moment(this.props.data.rejectedDate).format("DD/MM/YYYY HH:mm")}:{" "}
            {this.props.data.rejectionReason}
          </Typography>
        )}
        <KpsEditor initialContent={this.props.data.content} readOnly />
        <div style={{ marginTop: 10, textAlign: "center" }}>
          {this.props.data.status !== "RESOLVED" && (
            <Button
              disabled={
                this.props.data.status === "REJECTED" ||
                !currentUserHasRole(Role.BE_EXPERT)
              }
              onClick={(e) => this.setState({ anchorEl: e.currentTarget })}
              variant="outlined"
              color="default"
            >
              {t("rework_reject_request_button")}
            </Button>
          )}
          <Popover
            open={Boolean(this.state.anchorEl)}
            anchorEl={this.state.anchorEl}
            onClose={() => this.setState({ anchorEl: null })}
            anchorOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "left",
            }}
          >
            <DialogTitle>{t("rework_reject_header")}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {t("rework_reject_subheader")}
              </DialogContentText>
              <KpsTextField
                variant="outlined"
                style={{ width: "100%" }}
                rows={4}
                label={t("rework_reject_label")}
                value={this.state.rejectReason}
                onChange={(e) =>
                  this.setState({ rejectReason: e.target.value })
                }
                multiline
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.setState({ anchorEl: null })}
                color="default"
              >
                {t("global_cancel")}
              </Button>
              <Button onClick={this.rejectRework} color="default">
                {t("rework_reject_button")}
              </Button>
            </DialogActions>
          </Popover>
        </div>
      </div>
    );
  };

  rejectRework = () => {
    contentClient
      .post(`/rework/${this.props.data.id}/reject`, {
        reason: this.state.rejectReason,
      })
      .then((res) => {
        this.props.enqueueSnackbar("Rework rejected", { variant: "success" });
        this.setState({ anchorEl: null });
        this.props.onReject && this.props.onReject(res.data);
      });
  };

  extendedNoSideBarInfo = (settings) => {
    const { classes } = this.props;
    if (!settings) {
      settings = [];
      for (let i = 0; i < this.props.reworkOptions.length; i++) {
        settings.push({ label: this.props.reworkOptions[i], order: i });
      }
    } else {
      settings = JSON.parse(settings);
    }
    let extendedString = (
      <Table size="small">
        <TableBody>
          {settings.map((setting, idx) => {
            return (
              <TableRow key={idx}>
                <TableCell>{this.props.t(setting.label)}</TableCell>
                {this.getSettingInfo(setting)}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
    return extendedString;
  };
  returnSettingItem = (settings) => {
    const { classes } = this.props;
    let fontWeight = {
      fontWeight: this.props.fullscreen ? "bold" : "normal",
      paddingRight: this.props.theme.spacing(1),
    };
    return (
      <span className={classes.iconSpan}>
        {settings === "settings_urgency" &&
          `${this.props.t("settings_urgency")}: ${this.props.data.urgency}`}
        {settings === "settings_target_completion_date" &&
          `${this.props.t("settings_target_completion_date")}: ${moment(this.props.data.targetCompletionDate).format("LLL")}}`}
        {settings === "settings_date_created" &&
          `${this.props.t("settings_date_created")}: ${moment(this.props.data.dateCreated).format("LLL")}`}
        {settings === "settings_originator" && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div style={fontWeight}>
              {this.props.t("settings_originator")}
              :{" "}
            </div>
            <div>
              <DisplayUser
                noAvatar
                userId={this.props.data.creator.userId}
                user={this.props.data.creator}
              />
            </div>
          </div>
        )}
        {settings === "settings_author" &&
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div style={fontWeight}>
              {this.props.t("settings_author")}
              :{" "}
            </div>
            <div>
              <DisplayUser
                noAvatar
                userId={this.props.data.author.userId}
                user={this.props.data.author}
              />
            </div>
          </div>
        }
        {settings === "settings_revision" &&
          `${this.props.t("global_title")}: ${this.props.data.targetTitle}`}
        {settings === "settings_status" && `${this.props.t("settings_status")}: ${this.props.data.status}`}
        {settings === "settings_location" &&
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div style={fontWeight}>
              {this.props.t("settings_location")}
              :{" "}
            </div>
            <div>
              <DisplayLocation
                type={"KNOWLEDGE_ITEM"}
                itemId={this.props.data.knowledgeItemId}
                topicId={this.props.data.topicId}
                title={this.props.data.targetTitle}
              />
            </div>
          </div>        
        }
      </span>
    );
  };
  secondaryInfo = (settings) => {
    if (this.props.fullscreen) {
      this.setState({ secondaryString: "" });
    } else {
      if (this.props.secondaryInfo) {
        return this.props.secondaryInfo;
      }
      if (!settings) {
        settings = "settings_urgency";
      }

      const { classes } = this.props;
      let info = (
        <div>
          {this.props.fullscreen && settings
            ? settings.map((setting) => {
                return this.returnSettingItem(setting);
              })
            : this.returnSettingItem(settings)}
        </div>
      );
      this.setState({ secondaryString: info });
    }
  };
}

const mapStateToProps = (state) => ({
  reworkOptions: state.selectionOption.reworkSettingsOptions,
  currentUser: state.user.currentUser,
});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {
    forwardRef: true,
  }
)(withStyles(styles)(withRouter(withTheme(withTranslation()(withSnackbar(ItemRework))))));
